<template>
  <div class="top-trader-container">
    <div class="item">
      <div class="event-finish">
        <img src="/static/svg/event-finish.svg">
        <p>End of "SUPER TRADER, SUPER KULAPer" Campaign</p>
      </div>
    </div>
    <!-- Rewards -->
    <div class="item">
      <a
        class="link-award-announcement"
        @click="openLinkNewTab"
      >
        <img src="static/svg/loud-speaker.svg">
        <span>Award announcement</span>
      </a>
    </div>
    <TotalTopTrade
      :total-valume="totalValume"
      :top-token-trade="topTokenTrade"
    />
    <div class="item">
      <p class="notice-text">Notice: The information will be updating after <b>12</b> block confirmations.</p>
    </div>
    <RankingBoard
      :top-traders="topTraders"
    />
    <div
      v-if="myStat.length > 0 && !isMeInTopTen"
      class="my-position"
    >
      <div class="title-box">
        <span class="title-box title">${{ amouhntToBeWin | numberWithComma(0) }} to be Winner</span>
      </div>
      <TraderCard
        :rank="0"
        :data="myStat[0]"
      />
    </div>
  </div>
</template>

<script>
import TotalTopTrade from './components/TotalTopTrade'
import RankingBoard from './components/RankingBoard'
import TraderCard from './components/TraderCard'
import { kulapApi } from '@/resources'
import { TOKENS_INFO } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'TopTrader',
  components: {
    TotalTopTrade,
    RankingBoard,
    TraderCard
  },
  data () {
    return {
      startTimeEvent: '2021-01-11T00:00:00+07:00',
      endTimeEvent: '2021-02-11T23:59:59+07:00',
      totalValume: 0,
      topTokenTrade: {
        labelCode: '-',
        fullName: '-'
      },
      topTraders: [],
      myStat: [],
      interval: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    isMeInTopTen () {
      if (this.myStat.length && this.topTraders.length) {
        return this.topTraders.filter(trader => trader.userId === this.myStat[0].userId).length > 0
      } else {
        return true
      }
    },
    amouhntToBeWin () {
      if (this.myStat.length && this.topTraders.length) {
        return this.topTraders[0].totalVolume - this.myStat[0].totalVolume
      }
      return 0
    }
  },
  watch: {
    user (val) {
      this.getTopTradeEvent()
    }
  },
  async created () {
    this.getTopTradeEvent()
    this.interval = setInterval(async () => {
      try {
        await this.getTopTradeEvent()
      } catch (error) {
        clearInterval(this.interval)
        console.error('error: Get top trade event.', error)
      }
    }, 1000 * 30)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    openLinkNewTab () {
      window.open('https://bit.ly/SuperKULAPerAnnouncingTheWinner', '_blank')
    },
    async getTopTradeEvent () {
      const { data } = await kulapApi.getTopTradeEvent(this.user.id)
      if (Object.keys(data.overAllTrade).length) {
        this.totalValume = data.overAllTrade.totalVolume
        this.topTokenTrade = {
          labelCode: data.overAllTrade.tokenTopTrade,
          fullName: TOKENS_INFO.main[data.overAllTrade.tokenTopTrade].name
        }
      }

      this.topTraders = data.userTopTrade.map(value => {
        return {
          userImage: value.profilePicture || require('../../assets/svg/default-user-avatar.svg'),
          email: value.email || '',
          totalVolume: value.tradeVolumeUsd,
          token: {
            labelCode: value.topToken[0].token,
            fullName: TOKENS_INFO.main[value.topToken[0].token].name
          },
          userId: value.userId
        }
      })
      this.myStat = data.myStat.map(value => {
        return {
          userImage: value.profilePicture || require('../../assets/svg/default-user-avatar.svg'),
          email: value.email || '',
          totalVolume: value.tradeVolumeUsd,
          token: {
            labelCode: value.topToken[0].token,
            fullName: TOKENS_INFO.main[value.topToken[0].token].name
          },
          userId: value.userId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.top-trader-container {
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  margin: 50px 0 0 0;
  padding: 40px 0 0;
}
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.link-award-announcement {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 15px;
  padding-bottom: 3px;
  border-bottom: solid 2px;
  border-color: #1A53F0;
  span {
    color: #1A53F0;
    line-height: 25px;
  }
  img {
    margin-right: 10px;
  }
}
.notice-text {
  font-size: 15px;
}
.my-position {
  display: flex;
  align-items: center;
  margin-bottom: 60px;
  flex-direction: column;
  gap: 18px;
}
.title-box {
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 15px;
  margin-bottom: 20px;
  .title {
    font-family: Roboto;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0em;
  }
  .icon {
    height: auto;
    max-width: 100%;
    margin-right: 13px;
  }
}
.event-finish {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10px 30px;
  img {
    margin-bottom: 20px;
    width: 100px;
  }
  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 47px;
    color: #3F5EAB;
    text-align: center;
  }
}
@media screen and (max-width: 1020px){
  .notice-text {
    line-height: 25px;
    max-width: 250px;
    margin-bottom: 12px;
  }
  .link-award-announcement {
    img {
      width: 25px;
    }
  }
  .top-trader-container {
    padding: 40px 0;
  }
  .event-finish {
    margin: 0 10px 21px;
    img {
      width: 55px;
      margin-bottom: 13px;
    }
    p {
      font-size: 21px;
      line-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/features/TopTrader/index.vue